module.exports = __webpack_public_path__ + "img/icon-gift.7b6bf8c.webp";